var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "root", attrs: { "max-width": "700" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("components.purchases.deleted-browse.title")) +
              " "
          ),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c("w-data-table", {
        attrs: {
          items: _vm.data,
          columns: _vm.columns,
          "use-checkboxes": false,
          "order-direction": _vm.orderAscending,
          "order-column": _vm.orderColumn,
          "selected-items": _vm.selectedItems,
          "column-resize-handle": "",
        },
        on: {
          "item-clicked": function ($event) {
            return _vm.onItemClick($event)
          },
          scroll: function ($event) {
            return _vm.onScroll($event)
          },
        },
      }),
      _c(
        "w-modal",
        { attrs: { value: _vm.openedItem != null, "full-height": "" } },
        [
          _vm.openedItem
            ? _c(
                "w-card",
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.openedItem.ComputedFriendlyID)),
                  ]),
                  _c(
                    "w-scroll-view",
                    {
                      style: { flexGrow: 1 },
                      attrs: { tag: "w-card-content" },
                    },
                    [_c("w-json-viewer", { attrs: { value: _vm.openedItem } })],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "cancel",
                          attrs: { icon: "ban" },
                          on: {
                            click: function ($event) {
                              _vm.openedItem = null
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: { icon: "check" },
                          on: {
                            click: function ($event) {
                              return _vm.restoreOpenedItem()
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("components.sales.deleted-browse.restore")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }